import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Defer Meta Pixel loading to not block initial page render
    const timeoutId = setTimeout(() => {
      // Initialize Meta Pixel
      if (!window.fbq) {
        window.fbq = function () {
          window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = window.fbq;
        window.fbq.push = window.fbq;
        window.fbq.loaded = true;
        window.fbq.version = '2.0';
        window.fbq.queue = [];
      }
      // Load the script
      const script = document.createElement('script');
      script.async = true;
      script.defer = true; // Add defer attribute
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Initialize pixel
      window.fbq('init', '4131379627133202');
      window.fbq('track', 'PageView');
      // Add noscript pixel
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=4131379627133202&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }, 1000); // Delay by 1 second
    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
  return null;
}